import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getYMax, mapDatasetTitles, getUnit } from "../utils";
import { ChartStateParams } from "./types";

export const useChartState = (params: ChartStateParams) => {
  const { title, device, graphType, customGraph, chartData } = params;

  const { t } = useTranslation();

  const yMax = getYMax(chartData, device, graphType, customGraph);
  const roundedYMax = yMax && Math.ceil(yMax);

  return useMemo(
    () => ({
      chartData: mapDatasetTitles(chartData, title, graphType, t),
      yMax: roundedYMax,
      unitMeasurement: getUnit(graphType, customGraph, t),
    }),
    [chartData, title, graphType, customGraph]
  );
};
